module.exports = __webpack_public_path__ + "img/corporateVision-img3.ec3c3b55.png";